import React, { useState, useEffect } from "react";
import { Box, Button, IconButton, Typography, Drawer } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { Container } from "@mui/system";
import location from "./Images/Location.png";
import notification from "./Images/notification.png";
import memoji from "./Images/Memoji.png";
import pointer from "./Images/Pointer.png";
import searchIcon from "./Images/search_icon.png";
import {useNavigate} from "react-router-dom"

export default function FilterNavbar() {
  const navigate = useNavigate();
  const [navColor, setnavColor] = useState("transparent");
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#F9FFFF") : setnavColor("transparent");
    // window.scrollY > 10 ? setnavSize("5rem") : setnavSize("5rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const [value, setValue] = useState();

  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenDrawer(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenDrawer(false);
  };

  return (
    <>
      <Box
        sx={{
          borderBottom: "1px solid #F6F6F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "13vh"
        }}
        maxWidth
      >
        <Box sx={{ marginTop: 5, marginBottom: 3 }} maxWidth="xl">
          <Box
            component="container"
            sx={{
              margin: "0px",
              padding: "0px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: navColor,
            }}
          >
            <Box
              sx={{
                width: {
                  xl: "199.91px",
                  lg: "150px",
                  md: "150px",
                  sm: "150px",
                  xs: "100px",
                },
                height: { lg: "32px", md: "30px", sm: "28px", xs: "30px" },
                cursor:"pointer"
              }}
              onClick={()=>{
                navigate("/")
              }}
            >
              <img src="./images/eatcoast.svg" alt="" width="100%" />
            </Box>

            <Box
              sx={{
                display: { lg: "flex", md: "flex", sm: "none", xs: "none" },
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    width: { lg: "40px", md: "40px", sm: "25px", xs: "20px" },
                    height: { lg: "40px", md: "40px", sm: "25px", xs: "20px" },
                    paddingLeft: {
                      xl: "130.09px",
                      lg: "130.09px",
                      md: "30px",
                      sm: "50px",
                      xs: "30px",
                    },
                    paddingRight: "16px",
                    // paddingTop: "8px"
                  }}
                >
                  {/* <img
                    src="./images/Frame 720.svg"
                    alt=""
                    // height="auto"
                    style={{ marginRight: "20px" }}
                  /> */}
                </Box>
                <img style={{ marginRight: "20px" }} src={location} />

                <Box
                  sx={{
                    borderBottom: "2px solid",
                    color: "#F6F6F6",
                    width: {
                      lg: "169.57px",
                      md: "169.57px",
                      sm: "90px",
                      xs: "100px",
                    },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "400",
                      color: "#000000",
                      paddingTop: "4px",
                    }}
                  >
                    asdasdasd
                  </Typography>
                  <img src={pointer} />
                </Box>
                {/* <Box
                  sx={{
                    paddingLeft: "2px",
                    paddingTop: { lg: "8px", md: "8px", sm: "6px", xs: "4px" },
                    width: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                  }}
                >
                  <img
                    src="./images/gps.svg"
                    alt=""
                    width="100%"
                    height="auto"
                  />
                </Box> */}

                <Box sx={{ paddingLeft: "16.43px" }}>
                  <Input
                    // fullWidth
                    // sx={{width: {lg: "100%", md: "45%", sm: "200px"}}}
                    disableUnderline="true"
                    startAdornment={
                      <InputAdornment position="start">
                        <Box
                          sx={{
                            width: {
                              lg: "17.75px",
                              md: "17.75px",
                              sm: "14px",
                              xs: "12px",
                            },
                            height: "20.5px",
                          }}
                        >
                          <img
                            src={searchIcon}
                            style={{
                              position: "relative",
                              right: "15px",
                            }}
                          />
                        </Box>
                      </InputAdornment>
                    }
                    sx={{
                      borderColor: "#E1E1E6",
                      border: "1px solid",
                      width: {
                        xl: "390px",
                        lg: "390px",
                        md: "245px",
                        sm: "200px",
                        xs: "100px",
                      },
                      height: {
                        lg: "40px",
                        md: "36px",
                        sm: "30px",
                        xs: "30px",
                      },
                      borderRadius: "4px",
                      padding: "15px, 24px, 15px, 24px",
                      gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
                      backgroundColor: "#F6F6F6",
                      color: "#9EA3AE",
                      paddingLeft: "27.12px",
                    }}
                  ></Input>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    paddingLeft: {
                      xl: "136px",
                      lg: "112px",
                      md: "40px",
                      sm: "20px",
                      xs: "20px",
                    },
                  }}
                >
                  <Button
                    sx={{
                      border: "1px solid #F6F6F6",
                      height: {
                        lg: "45px",
                        md: "45px",
                        sm: "30px",
                        xs: "22px",
                      },
                      width: { lg: "30px", md: "30px", sm: "30px", xs: "22px" },
                    }}
                    variant="button"
                  >
                    <img src={notification} />
                  </Button>
                </Box>

                <Box>
                  <Button
                    size="small"
                    sx={{
                      marginLeft: {
                        xl: "8px",
                        lg: "8px",
                        md: "8px",
                        sm: "8px",
                        xs: "4px",
                      },
                      borderRadius: "6px",
                      fontSize: {
                        lg: "16px",
                        md: "12px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                      height: {
                        lg: "45px",
                        md: "45px",
                        sm: "30px",
                        xs: "22px",
                      },
                      width: { lg: "30px", md: "30px", sm: "30px", xs: "22px" },
                      backgroundColor: "#D5E6E5",
                      border: "none",
                      boxShadow: "0px 0px 0px",

                      // width: "97px",
                    }}
                    variant="contained"
                  >
                    <img src={memoji} />
                  </Button>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: { lg: "none", md: "none", sm: "flex", xs: "flex" },
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <Box>
                <IconButton aria-label="delete" onClick={handleClick}>
                  <MenuIcon />
                </IconButton>

                <Drawer
                  anchor="top"
                  open={openDrawer}
                  onClose={() => setOpenDrawer(false)}
                  width="100%"
                >
                  <Box>
                    <Box>
                      {" "}
                      <Button
                        sx={{
                          width: "100%",
                          justifyContent: "left",
                          textTransform: "capitalize",
                        }}
                      >
                        Cart
                      </Button>
                    </Box>
                    <Box>
                      {" "}
                      <Button
                        sx={{
                          width: "100%",
                          justifyContent: "left",
                          textTransform: "capitalize",
                        }}
                      >
                        Signup
                      </Button>
                    </Box>

                    <Box>
                      {" "}
                      <Button
                        sx={{
                          width: "100%",
                          justifyContent: "left",
                          textTransform: "capitalize",
                        }}
                      >
                        search
                      </Button>
                    </Box>
                  </Box>
                </Drawer>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
